/**
 * Whether the result list paints a coupon or wallet quote in place of the trips' own pricing.
 *
 * Same condition `TripList` swaps on: a coupon code in the search, or trips quoted for the wallet
 * discount. The quote arrives without BOOK-168 companions, so its cards stay in control (the card
 * gate needs a companion on the pricing it renders) while `trip.pricing` may still carry one.
 * List-level readers of the final-price arm (the price sort and the product-list impression) gate
 * on `trip.pricing`, so while this holds they stay in control and never evaluate GrowthBook: they
 * would otherwise log the exposure, and hold the tab final, for a user who saw only control cards.
 * BOOK-169 lifts this by annotating the quote.
 *
 * @param {Immutable.Map} search - The search state.
 * @returns {boolean} Whether a coupon or wallet quote is painted.
 */
const listPaintsQuote = (search) => {
  if (search.get('couponCode')) return true;

  const walletTrips = search.getIn(['discountedTripsByCoupon', search.get('walletTypeDiscount')]);
  return Boolean(walletTrips?.length || walletTrips?.size);
};

export default listPaintsQuote;
